import React, { useState, useEffect } from "react";
import millify from "millify";
import { Link } from "react-router-dom";
import { Card, Row, Col, Input } from "antd";

import { useGetCryptosQuery } from "../services/cryptoApi";
import Loader from "./Loader";

// Cryptocurrencies
const Cryptocurrencies = ({ simplified }) => {
  const count = simplified ? 10 : 100;
  const { data: cryptosList, isFetching } = useGetCryptosQuery(count);
  const [cryptos, setCryptos] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  // Filter search data
  useEffect(() => {
    const re = RegExp(
      `.*${searchTerm.toLowerCase().replace(/\s+/g, "").split("").join(".*")}.*`
    );

    const filteredData = cryptosList?.data?.coins.filter((coin) =>
      coin.name.toLowerCase().match(re)
    );

    setCryptos(filteredData);
  }, [cryptosList, searchTerm]);

  // Loading
  if (isFetching) return <Loader />;

  return (
    <>
      {/* Search Crypocurrency */}
      {!simplified && (
        <div className="search-crypto">
          <Input
            placeholder="Search Crypocurrency..."
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      )}

      <Row
        gutter={[32, 32]}
        className="crypto-card-container"
        style={!cryptos?.length && { justifyContent: "center" }}
      >
        {/* Show Crypocurrency */}
        {cryptos?.length ? (
          cryptos?.map((currency) => (
            <Col
              xs={24}
              sm={12}
              lg={6}
              className="crypto-card"
              key={currency.uuid}
            >
              <Link to={`/crypto/${currency.uuid}`}>
                <Card
                  title={`${currency.rank}. ${currency.name}`}
                  extra={
                    <img
                      className="crypto-image"
                      src={currency.iconUrl}
                      alt={currency.name}
                    />
                  }
                  hoverable
                >
                  <p>Price: {millify(currency.price)}</p>
                  <p>Market Cap: {millify(currency.marketCap)}</p>
                  <p>Daily Change: {millify(currency.change)}%</p>
                </Card>
              </Link>
            </Col>
          ))
        ) : (
          // No Crypocurrencies found
          <p style={{ textAlign: "center" }}>No Crytocurrencies Found.</p>
        )}
      </Row>
    </>
  );
};

export default Cryptocurrencies;
